import { render } from "./TheBlock.vue?vue&type=template&id=45deabfc"
import script from "./TheBlock.vue?vue&type=script&lang=js"
export * from "./TheBlock.vue?vue&type=script&lang=js"

import "./TheBlock.vue?vue&type=style&index=0&id=45deabfc&lang=css"

import exportComponent from "D:\\CUFE24\\Cources\\Vue JS Net Ninja\\third-task-reaction-timer-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__